// extracted by mini-css-extract-plugin
export default {"button":"CheckboxButton_button__1D81y","icon":"CheckboxButton_icon__nNPPj","label":"CheckboxButton_label__ovUho"};